import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconAlertComponent } from "./med-icon-alert.component";

@NgModule({
  declarations: [
    MedIconAlertComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconAlertComponent,
  ],
})
export class MedIconAlertModule { }
